<template>
    <div class="bg-2025-light-beige">
        <div class="container mx-auto md:px-0 px-4 py-8">
            <div class="flex flex-col md:flex-row justify-between gap-8">
                <div class="flex flex-col gap-8 w-full">
                    <client-only>
                        <FooterSocialNewsletter />
                    </client-only>
                    <FooterSocialSocial />
                </div>
                <FooterNav />
            </div>
        </div>
    </div>
</template>

<script>
import FooterSocialSocial from '~/components/FooterSocialSocial';
import FooterSocialAboutUs from '~/components/FooterSocialAboutUs';
import FooterSocialNewsletter from '~/components/FooterSocialNewsletter';
import FooterNav from './FooterNav.vue';

export default {

    components: {
        FooterNav,
        FooterSocialSocial,
        FooterSocialAboutUs,
        FooterSocialNewsletter,
    },

};
</script>

<style scoped>
.background {
    background-color: #fef5f6;
}
</style>
